import axios from 'axios'

export const loadWpdata =  async ({ commit }) => {
  try {
    const req = await axios.get(`${process.env.VUE_APP_API_URL}wp-json/wp/v2/shop/settings`);
    commit('setWpdata', req.data.req.data)
  } catch (error) {
    return commit('fetchFail',error)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js